// @ts-nocheck
import * as Types from "../../../types/types";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type GetVacuumAdvisorDataQueryVariables = Types.Exact<{
  serverId: Types.Scalars["ID"]["input"];
  databaseId?: Types.InputMaybe<Types.Scalars["ID"]["input"]>;
}>;

export type GetVacuumAdvisorDataQuery = {
  __typename?: "GraphqlQuery";
  getServerDetails: {
    __typename?: "Server";
    id: string;
    integratedLogInsights: boolean;
    name: string;
    createdAt: number;
    blockSize: number;
    xactPerSecSummary?: number | null;
    txidUtilizationSummary?: number | null;
    autovacuumAvgWorkerCount: number;
    oldestXminAssignedAgo?: number | null;
    totalBloat: {
      __typename?: "Bloat";
      estimatedTableBytes: number;
      idealTableBytes: number;
      estimatedAt?: number | null;
      numTotalTables: number;
      numTablesWithStats: number;
    };
    vacuumCount: {
      __typename?: "VacuumCount";
      autovacuumCount: number;
      antiWraparoundAutovacuumCount: number;
      totalVacuumRunsCount: number;
      manualVacuumRunsCount: number;
      skippedCount: number;
    };
    databasesWithoutColumnStats: {
      __typename?: "DatabasePartialList";
      totalCount: number;
      databases: Array<{
        __typename?: "Database";
        id: string;
        datname?: string | null;
      }>;
    };
  };
  getLatestPostgresServerStats?: {
    __typename?: "PostgresServerStats";
    id: string;
    isPrimary: boolean;
  } | null;
  getIssues: Array<{
    __typename?: "Issue";
    id: string;
    databaseId?: string | null;
    checkGroupAndName: string;
    description: string;
    descriptionTemplate: string;
    severity: string;
    state: string;
    details: any;
    groupingKey: any;
    descriptionReferences: Array<{
      __typename?: "IssueDescriptionReference";
      param: string;
      name: string;
      path?: string | null;
    }>;
    references: Array<{
      __typename?: "IssueReference";
      referentId: string;
      kind: string;
      name: string;
      url: string;
    }>;
  }>;
  getIssueCounts: Array<{
    __typename?: "IssueSummary";
    id: string;
    checkGroupAndName: string;
    newCount: number;
    resolvedCount: number;
  }>;
  getPostgresSettings: Array<{
    __typename?: "PostgresSetting";
    group?: string | null;
    source?: string | null;
    name: string;
    resetValue?: string | null;
    resetValuePretty?: string | null;
    bootValuePretty?: string | null;
  }>;
  getVacuumInsightStatus: Array<{
    __typename?: "VacuumInsightStatus";
    id: string;
    checkGroupAndName: string;
    lastRunAt: number;
  }>;
};

export const GetVacuumAdvisorDataDocument = gql`
  query GetVacuumAdvisorData($serverId: ID!, $databaseId: ID) {
    getServerDetails(serverId: $serverId) {
      id
      integratedLogInsights
      name
      createdAt
      totalBloat {
        estimatedTableBytes
        idealTableBytes
        estimatedAt
        numTotalTables
        numTablesWithStats
      }
      blockSize
      xactPerSecSummary
      txidUtilizationSummary
      autovacuumAvgWorkerCount
      oldestXminAssignedAgo
      vacuumCount {
        autovacuumCount
        antiWraparoundAutovacuumCount
        totalVacuumRunsCount
        manualVacuumRunsCount
        skippedCount
      }
      databasesWithoutColumnStats(limit: 5, focusDatabaseId: $databaseId) {
        totalCount
        databases {
          id
          datname
        }
      }
    }
    getLatestPostgresServerStats(serverId: $serverId) {
      id
      isPrimary
    }
    getIssues(
      serverId: $serverId
      checkGroupsAndNames: [
        "vacuum/inefficient_index_phase"
        "vacuum/xmin_horizon"
        "vacuum/insufficient_vacuum_frequency"
        "vacuum/txid_wraparound"
        "vacuum/mxid_wraparound"
      ]
    ) {
      id
      databaseId
      checkGroupAndName
      description
      descriptionTemplate
      descriptionReferences {
        param
        name
        path
      }
      severity
      state
      details
      references {
        referentId
        kind
        name
        url
      }
      groupingKey
    }
    getIssueCounts(
      serverId: $serverId
      checkGroupsAndNames: [
        "vacuum/inefficient_index_phase"
        "vacuum/xmin_horizon"
        "vacuum/insufficient_vacuum_frequency"
        "vacuum/txid_wraparound"
        "vacuum/mxid_wraparound"
      ]
    ) {
      id
      checkGroupAndName
      newCount
      resolvedCount
    }
    getPostgresSettings(
      serverId: $serverId
      patterns: ["vacuum%", "autovacuum%", "log_autovacuum_min_duration"]
    ) {
      group
      source
      name
      resetValue
      resetValuePretty
      bootValuePretty
    }
    getVacuumInsightStatus(serverId: $serverId) {
      id
      checkGroupAndName
      lastRunAt
    }
  }
`;

/**
 * __useGetVacuumAdvisorDataQuery__
 *
 * To run a query within a React component, call `useGetVacuumAdvisorDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVacuumAdvisorDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVacuumAdvisorDataQuery({
 *   variables: {
 *      serverId: // value for 'serverId'
 *      databaseId: // value for 'databaseId'
 *   },
 * });
 */
export function useGetVacuumAdvisorDataQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetVacuumAdvisorDataQuery,
    GetVacuumAdvisorDataQueryVariables
  > &
    (
      | { variables: GetVacuumAdvisorDataQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetVacuumAdvisorDataQuery,
    GetVacuumAdvisorDataQueryVariables
  >(GetVacuumAdvisorDataDocument, options);
}
export function useGetVacuumAdvisorDataLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetVacuumAdvisorDataQuery,
    GetVacuumAdvisorDataQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetVacuumAdvisorDataQuery,
    GetVacuumAdvisorDataQueryVariables
  >(GetVacuumAdvisorDataDocument, options);
}
// @ts-ignore
export function useGetVacuumAdvisorDataSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetVacuumAdvisorDataQuery,
    GetVacuumAdvisorDataQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetVacuumAdvisorDataQuery,
  GetVacuumAdvisorDataQueryVariables
>;
export function useGetVacuumAdvisorDataSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetVacuumAdvisorDataQuery,
        GetVacuumAdvisorDataQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetVacuumAdvisorDataQuery | undefined,
  GetVacuumAdvisorDataQueryVariables
>;
export function useGetVacuumAdvisorDataSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetVacuumAdvisorDataQuery,
        GetVacuumAdvisorDataQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetVacuumAdvisorDataQuery,
    GetVacuumAdvisorDataQueryVariables
  >(GetVacuumAdvisorDataDocument, options);
}
export type GetVacuumAdvisorDataQueryHookResult = ReturnType<
  typeof useGetVacuumAdvisorDataQuery
>;
export type GetVacuumAdvisorDataLazyQueryHookResult = ReturnType<
  typeof useGetVacuumAdvisorDataLazyQuery
>;
export type GetVacuumAdvisorDataSuspenseQueryHookResult = ReturnType<
  typeof useGetVacuumAdvisorDataSuspenseQuery
>;
export type GetVacuumAdvisorDataQueryResult = Apollo.QueryResult<
  GetVacuumAdvisorDataQuery,
  GetVacuumAdvisorDataQueryVariables
>;
